export const API_ROUTES = {
  'auth.login': `/auth/login`,
  'auth.refresh': `/auth/refresh`,
  'auth.logout': `/auth/logout`,
  'auth.forgot-password': `/reset-password/code`,
  'auth.reset-password': `/reset-password`,

  'profile.details': `/profile`,

  'mixpanel': `/mixpanel/link`,

  parents: `/parent-users`,
  children: `/child-users`,
} as const;
